<template>
  <header class="header-auth">
    <a href="#">
      <img src="@/assets/logo.svg" width="160" height="36" />
    </a>

    <div class="menu-mobile" @click="toggleMenu">
      <img src="@/assets/menu-hamburguer.svg" />
    </div>

    <div class="right-side">
      <input type="text" />

      <TheAvatar
        :img="require('@/assets/avatar/avatar-profile.svg')"
        max-width="34px"
      />

      <p>{{ `${users.firstName} ${users.lastName}` }}</p>

      <img
        src="@/assets/icons/arrow-menu.svg"
        class="submenu-button"
        @click="toogleSubMenu"
      />

      <div class="submenu-options" :class="showSubMenu">
        <ul>
          <li @click="closeSubMenu">
            Configurações
          </li>
          <li @click="redirect">
            Página Administrativa
          </li>
          <li @click="submitLogout">
            Sair
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { bus } from '@/main';
import TheAvatar from '@/views/layout/avatar/';
import axios from 'axios';

export default {
  name: 'TheHeader',

  components: {
    TheAvatar,
  },

  data() {
    return {
      subMenu: false,
      users: [],
    };
  },
  emits: ['toggleMenu'],

  computed: {
    ...mapState('auth', ['resume']),

    showSubMenu() {
      return { active: this.subMenu };
    },
  },

  async created() {
    await this.fetchUsers();
    console.log(this.users);
  },

  methods: {
    ...mapActions('auth', ['logout']),

    toggleMenu() {
      bus.$emit('toggleMenu');
    },

    toogleSubMenu() {
      this.subMenu = !this.subMenu;
    },

    closeSubMenu() {
      if (this.subMenu) {
        this.subMenu = false;
      }
    },

    submitLogout() {
      this.closeSubMenu();

      this.logout();

      this.$router.push({ name: 'Home' });
    },

    redirect() {
      this.$router.push('/admin');
    },
    async fetchUsers() {
      const id = localStorage.getItem('user');
      const token = localStorage.getItem('token');
      const { data } = await axios.get(
        `${process.env.VUE_APP_API}/user/${id}`,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );
      this.users = data;
    },
  },
};
</script>

<style lang="scss" scoped>
/* HEADER */
header.header-auth {
  height: 64px;
  background: #1226aa;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9;
  justify-content: space-between;
  display: flex;
  padding: 12px 24px;

  .menu-mobile {
    display: none;
    cursor: pointer;
  }

  .right-side {
    display: flex;
    justify-content: center;
    align-items: center;

    input {
      width: 360px;
      height: 40px;
      padding: 10px 17px;
      border-radius: 90px;
      border: none;
      background: #3344b6 url('../../../assets/icons/search.svg') right 17px
        center no-repeat;
      color: #fff;
      margin-right: 20px;
      &:focus {
        outline: none;
      }
    }

    p {
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 400;
      font-size: 1rem;
      letter-spacing: 1px;
      margin: 0 10px;
    }

    .submenu-button {
      cursor: pointer;
    }

    .submenu-options {
      background: white;
      position: absolute;
      top: 45px;
      right: 30px;
      border-radius: 16px;
      overflow: hidden;
      display: none;
      box-shadow: 0px 0px 0px 1px rgba(63, 63, 68, 0.05),
        0px 1px 3px rgba(63, 63, 68, 0.15);

      &.active {
        display: block;
      }

      ul {
        list-style: none;

        li {
          padding: 20px;
          cursor: pointer;

          &:hover {
            background: rgba(246, 249, 253, 1);
            color: rgba(46, 58, 89, 1);
          }
        }
      }
    }
  }
}

#avatar .responsive {
  display: none;
}

@media (max-width: 768px) {
  header.header-auth {
    a {
      display: none;
    }

    .menu-mobile {
      display: flex;
    }

    div {
      input {
        width: 100%;
        max-width: 52px;
      }

      p {
        display: none;
      }
    }
  }
}
</style>
